module.exports = __webpack_public_path__ + "img/shogi_2021_pack_4_0001.bbb4e49f.png";